import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import store from '../store'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
    },
    {
      path: '/pr/:id/:version/annotation/:annotoriousID',
      name: 'Painted Representation - Annotation',
      component: () => import('@/views/depiction'),
      props: true
    },
    {
      path: '/pr/:id/:version?',
      name: 'Painted Representation',
      component: () => import('@/views/depiction'),
      props: route => ({
        id: route.params.id,
        version: route.params.version || 'current' // Standardwert für version
      }),
      beforeEnter: (to, from, next) => {
        if (!to.params.version) {
          // Wenn keine Version angegeben ist, leite auf die URL mit `version = "current"` um
          next({
            path: `/pr/${to.params.id}/current`,
            replace: true
          });
        } else {
          next();
        }
      }
    },
    {
      path: '/pr/',
      name: 'Painted Representation Filter',
      component: () => import('@/views/depictionFilter'),
      props: true
    },
    {
      path: '/kmt/:id/:version?',
      name: 'KMT',
      component: () => import('@/views/iconography'),
      props: route => ({
        id: route.params.id,
        version: route.params.version || 'current' // Standardwert für version
      }),
      beforeEnter: (to, from, next) => {
        if (!to.params.version) {
          // Wenn keine Version angegeben ist, leite auf die URL mit `version = "current"` um
          next({
            path: `/kmt/${to.params.id}/current`,
            replace: true
          });
        } else {
          next();
        }
      }
    },
    {
      path: '/iconography/:id/:version?',
      name: 'Iconography',
      component: () => import('@/views/iconography'),
      props: route => ({
        id: route.params.id,
        version: route.params.version || 'current' // Standardwert für version
      }),
      beforeEnter: (to, from, next) => {
        if (!to.params.version) {
          // Wenn keine Version angegeben ist, leite auf die URL mit `version = "current"` um
          next({
            path: `/iconography/${to.params.id}/current`,
            replace: true
          });
        } else {
          next();
        }
      }
    },
    {
      path: '/iconography/',
      name: 'KMT Filter',
      component: () => import('@/views/iconographyFilter')
    },
    {
      path: '/kmt/',
      name: 'KMT Filter',
      component: () => import('@/views/iconographyFilter')
    },
    {
      path: '/bibliography/',
      name: 'Bibliography',
      component: () => import('@/views/bibliographyFilter')
    },
    {
      path: '/bibliography/:id',
      name: 'Bibliography',
      component: () => import('@/views/bibliography'),
      props: true
    },
    {
      path: '/bib/',
      name: 'Bibliography',
      component: () => import('@/views/bibliographyFilter')
    },
    {
      path: '/bib/:id',
      name: 'Bibliography',
      component: () => import('@/views/bibliography'),
      props: true
    },
    {
      path: '/cave/',
      name: 'Cave',
      component: () => import('@/views/caveFilter'),
      props: true
    },
    {
      path: '/search',
      name: 'Search',
      component: Home,
      props: route => ({ isSearch: true, term: route.query.term })
    },
    {
      path: '/cave/:id',
      name: 'Cave',
      component: () => import('@/views/cave'),
      props: true
    },
    {
      path: '/impressum/',
      name: 'Impressum',
      component: () => import('@/views/impressum'),
      props: true
    },
    {
      path: '/tour/',
      name: 'Virtual Tour',
      component: () => import('@/views/tour'),
      props: true
    },
    {
      path: '/news/',
      name: 'News',
      component: () => import('@/views/news'),
      props: true
    },
    {
      path: '/forum/',
      name: 'Forum on Chronological Questions',
      component: () => import('@/views/forumFilter'),
      props: true
    },
    {
      path: '/about/',
      name: 'About the Project',
      component: () => import('@/views/about'),
      props: true
    },
    {
      path: '/game/',
      name: 'Game',
      component: () => import('@/views/game'),
      props: true
    },
    { path: "/404",
      component:  () => import('@/views/pageNotFound'),
    },
    {
      // This is a hack to use :to tag for absolute paths.
      path: "/http*",
      beforeEnter: to => {
        window.open(to.fullPath.substring(1), '_blank');
      }
    },
    {
      path: "/:catchAll(.*)", // Unrecognized path automatically matches 404
      redirect: '/404',
    }
  ]
})
router.beforeEach((to, from, next) => {
  console.log("to", to)
  let breadcrumb = [
    {
      text: 'Home',
      disabled: false,
      href: '/',
    },
  ]
  if (to.path !== "/"){
    breadcrumb.push(
      {
        text: to.name,
        disabled: false,
        href: to.fullPath.split(to.params.id)[0],
      }
    )
    if (Object.keys(to.params).length > 0){
      breadcrumb.push(
        {
          text: to.name + ' Entry ' + to.params.id,
          disabled: false,
          href: to.fullPath,
        }
      )
    }
    breadcrumb[breadcrumb.length - 1].disabled = true
  } else {
    breadcrumb = []
  }
  if (breadcrumb.length === store.state.breadcrumb.lenth){
    let same = true
    for (let i = 0; i < breadcrumb.length; i++){
      if (breadcrumb[i].href !== store.state.breadcrumb[i].href){
        same = false
        break
      }
    }
    if (!same){
      store.commit("setBreadcrumb", breadcrumb)
    }
  } else {
    store.commit("setBreadcrumb", breadcrumb)
  }
  if (to.name === 'Home' || to.name === 'News' || to.name === 'Login' || to.name === 'Game' || to.name === undefined){
    if (store.state.showMenu){
      store.commit("setShowMenu", false)
    }
  } else {
    if (!store.state.showMenu){
      store.commit("setShowMenu", true)
    }
  }
  next()
})
export default router
